module.exports = __webpack_public_path__ + "media/images/icons/material/chevron-left-59bfdc88747613838840ede0586177ee.svg";